import PlusIcon from "../../../../Assets/PlusIcon/Add.svg";
import ImageBox from './ImageBox';
import { useDispatch, useSelector } from 'react-redux';
import imageCompression from 'browser-image-compression';
import { fetchMedia } from '../../../../Features/storefrontSlice';
import { convertToWebP, getFileExtensionAndType } from '../../../../lib/utils/utils';
import { uploadFileToPresignedURL } from '../../../../lib/utils/apiCalls';
import { apiV1 } from "../../../../Auth/Interceptor";

async function uploadMedia(image) {
    let { extension, fileType } = getFileExtensionAndType(image);

    if (fileType.includes("image") || extension === "gif") {
        image = await convertToWebP(image);
        extension = "webp";
        fileType = "image/webp";
    }

    try {
        const callBody = {
            contentType: fileType,
            ext: extension,
        };

        const response = await apiV1.post('media/upload', callBody);
        const { data: { data } } = response;
        const { preSignedUrl, file: fileName, keys } = data;

        await uploadFileToPresignedURL(image, preSignedUrl);

        const convertedUrl = fileName.replace(
            "https://hyprcom-public.s3.ap-south-1.amazonaws.com",
            "https://imageserver.xenie.in"
        );

        try {
            const callBody = {
                keyData: keys,
                pic: convertedUrl,
            };

            await apiV1.post('media/create', callBody);
        } catch (err) {
            console.log(err);
        }
    }
    catch (err) {
        console.log(err);
    }
}

function MediaContainer() {
    const dispatch = useDispatch();

    const { media } = useSelector((state) => state.storefront.media);

    async function handleUploadMedia(e) {
        const image = e.target.files[0];

        try {
            if(image.size > 1048576) {
                try {
                    let compressedBlob = await imageCompression(image, {
                        maxSizeMB: 1,
                        maxWidthOrHeight: 1920,
                        useWebWorker: true
                    });

                    let compressedFile = new File([compressedBlob], image.name, { type: image.type, lastModified: Date.now() });

                    if (compressedFile) {
                        await uploadMedia(compressedFile);
                    }
                    else {
                        await uploadMedia(image);
                    }
                }
                catch(err) {
                    await uploadMedia(image);
                }
            }
            else {
                await uploadMedia(image);
            }
            dispatch(fetchMedia());
        }
        catch(err) {
            console.log(err);
        }

        e.target.value = null;
    }

    return (
        <div className='w-full max-h-full overflow-y-scroll no-scrollbar pb-3 flex flex-col relative'>
            <div className="p-3">
                <p className='font-bold text-2xl text-[#121212]'>Media</p>
            </div>

            <input 
                onChange={handleUploadMedia} 
                className='hidden' 
                type="file" 
                accept="image/*" 
                name="media" 
                id="media" 
            />

            {
                media?.length > 0 ? 
                <>
                    <div className="px-3 flex items-center justify-between">
                        <p>Store files &#40;{media.length}&#41;</p>

                        <div className='py-3'>
                            <label htmlFor='media' className='cursor-pointer underline font-semibold text-[16px] leading-5 text-[#1055EB]'>Upload from computer</label>
                        </div>
                    </div>

                    <div className="px-3 grid grid-cols-4 gap-x-1 gap-y-1">
                        {media.map(media => {
                            return (
                                <ImageBox 
                                    key={media.id} 
                                    media={media} 
                                />
                            );
                        })}
                    </div>
                </> : 
                <div className="absolute w-full h-full top-0 left-0 flex items-center justify-center">
                    <div className="flex flex-col items-center gap-6">
                        <p className='font-semibold text-[18px] leading-7 text-[#666666]'>No files are added yet</p>

                        <label htmlFor='media' className='cursor-pointer flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                            <div className="size-6 flex items-center justify-center">
                                <img src={PlusIcon} alt="" />
                            </div>

                            Upload from computer
                        </label>
                    </div>
                </div>
            }
        </div>
    );
}

export default MediaContainer;
